import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, CheckCircle } from "@phosphor-icons/react";
import api from "../lib/api";

export default function MyCarePlansCard() {
  const navigate = useNavigate();
  const [clients, setClients] = useState(null);

  useEffect(() => {
    api.get("/my/careplans").then((r) => setClients(r.data.clients || [])).catch(() => setClients([]));
  }, []);

  if (!clients || clients.length === 0) return null;

  return (
    <div className="mb-6 rounded-xl border border-stone-200 bg-white p-6 shadow-sm" data-testid="my-careplans-card">
      <p className="flex items-center gap-2.5 font-heading text-sm font-semibold text-stone-900">
        <BookOpen className="h-5 w-5 text-primary" /> My care plans
      </p>
      <p className="mt-1 text-xs text-stone-500">Review each client's plan before your shift and sign off. Some clients may also have the shared notebook open to you.</p>
      <div className="mt-3 divide-y divide-stone-100">
        {clients.map((c) => (
          <button key={c.client_id} onClick={() => navigate(`/my-careplan/${c.client_id}`)}
            className="flex w-full items-center justify-between gap-3 px-1 py-2.5 text-left transition-colors hover:bg-primary/5"
            data-testid={`my-careplan-${c.client_id}`}>
            <span className="text-sm font-medium text-stone-800">{c.client_name}</span>
            <span className="flex items-center gap-2 text-xs">
              {c.notebook && <span className="rounded-full bg-stone-100 px-2 py-0.5 text-stone-500">notebook</span>}
              {c.needs_ack
                ? <span className="rounded-full bg-[#C0392B]/10 px-2 py-0.5 font-semibold text-[#C0392B]">plan updated — review & sign</span>
                : c.signed_today
                  ? <span className="flex items-center gap-1 font-medium text-[#2F6B4F]"><CheckCircle size={13} /> signed today</span>
                  : <span className="font-semibold text-[#B7791F]">sign off for today →</span>}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
